export const socialNetworks: Array<TSocialNetwork> = [
  {
    title: 'ble',
    route: 'https://ble.ir/mazrae_app',
    icon: 'icon-Bale-icon',
  },
  {
    title: 'whatsApp',
    route: 'https://api.whatsapp.com/send?phone=989352593515',
    icon: 'icon-namewhatsapp',
  },
  {
    title: 'telegram',
    route: 'https://t.me/MazraeMan',
    icon: 'icon-Telegram',
  },
  {
    title: 'instagram',
    route: 'https://instagram.com/mazrae_app',
    icon: 'icon-nameinstagram',
  },
];
